module.exports = __webpack_public_path__ + "img/left-angle-lg.b13ee3ee.svg";